import React from "react";
import { ChevronRight } from "lucide-react";

const Hero = ({ onNavigate }) => {
  return (
    <section className="relative bg-gradient-to-br from-[#0f0f2e] via-[#1a1a3e] to-[#2a1a4e] text-white py-24 overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-20"></div>
      <div className="relative z-10 px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
        <div className="inline-block mb-4 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-[#d4af37] text-sm font-medium">
          New Collection 2025
        </div>
        <h2 className="mb-6 font-serif text-6xl leading-tight md:text-7xl">
          Timeless. Pure. Yours.
          <span className="block text-[#f0d98f]">Elegance</span>
        </h2>
        <p className="max-w-2xl mx-auto mb-10 text-xl text-gray-300">
          Discover the essence of elegance in handcrafted Silver 925 jewellery —
          designed to reflect your individuality.
        </p>
        <button
          onClick={() => onNavigate("shop")}
          className="group bg-gradient-to-r from-[#d4af37] to-[#c49a2e] text-white px-10 py-4 rounded-full font-semibold hover:from-[#c49a2e] hover:to-[#b38b28] transition shadow-xl shadow-[#d4af37]/20 inline-flex items-center space-x-2"
        >
          <span>Explore Collection</span>
          <ChevronRight className="w-5 h-5 transition group-hover:translate-x-1" />
        </button>
      </div>
    </section>
  );
};

export default Hero;
